import { AttomAdditionalInfo } from './attom.models';
import { DatafinitiExtraInfo } from './datafiniti.models';

export type ServiceIds = 'attom' | 'datafiniti';

export interface GeneralAdditionalInfo
  extends AttomAdditionalInfo,
    DatafinitiExtraInfo {
  attomId?: number;
  datafinitiId?: string;
}
